import { create } from 'zustand'
import type { AuthUser, OrgMembership } from '@/lib/api'

interface AuthStore {
  user: AuthUser | null
  orgs: OrgMembership[]
  activeOrg: OrgMembership | null
  isAuthenticated: boolean
  isLoading: boolean
  onboardingCompleted: boolean

  // Legacy API key support (backward compat)
  apiKey: string | null

  // Actions
  setSession: (user: AuthUser, orgs: OrgMembership[], activeOrg: OrgMembership) => void
  switchOrg: (org: OrgMembership) => void
  clearSession: () => void
  setLoading: (loading: boolean) => void
  setOnboardingCompleted: () => void

  // Legacy
  setApiKey: (key: string) => void
  clearApiKey: () => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  orgs: [],
  activeOrg: null,
  isAuthenticated: !!localStorage.getItem('relay_api_key'),
  isLoading: true,
  onboardingCompleted: false,

  // Legacy
  apiKey: localStorage.getItem('relay_api_key'),

  setSession: (user, orgs, activeOrg) => {
    set({
      user,
      orgs,
      activeOrg,
      isAuthenticated: true,
      isLoading: false,
      onboardingCompleted: user.onboardingCompleted ?? false,
    })
  },

  switchOrg: (org) => {
    set({ activeOrg: org })
  },

  clearSession: () => {
    localStorage.removeItem('relay_api_key')
    localStorage.removeItem('relay-theme')
    set({
      user: null,
      orgs: [],
      activeOrg: null,
      isAuthenticated: false,
      isLoading: false,
      onboardingCompleted: false,
      apiKey: null,
    })
  },

  setLoading: (loading) => {
    set({ isLoading: loading })
  },

  setOnboardingCompleted: () => {
    set({ onboardingCompleted: true })
  },

  // Legacy API key support
  setApiKey: (key: string) => {
    localStorage.setItem('relay_api_key', key)
    set({ apiKey: key, isAuthenticated: true, isLoading: false, onboardingCompleted: true })
  },

  clearApiKey: () => {
    localStorage.removeItem('relay_api_key')
    set({ apiKey: null, isAuthenticated: false, isLoading: false, user: null, orgs: [], activeOrg: null })
  },
}))
